// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"8af5f471","113":"8af5f471","165":"8af5f471","192":"05578750","280":"fa448b29","550":"39cb7635","813":"13edcf78","837":"c2ee484a","874":"bbd34205"}[chunkId] + ".chunk.css";
};